(() => {
  const root = document.querySelector('[data-stain-studio]');
  if (!root) return;
  const source = root.querySelector('[data-oak-source]');
  const preview = root.querySelector('[data-stain-preview]');
  const title = root.querySelector('h2[data-stain-name]');
  const buttons = [...root.querySelectorAll('button[data-stain-color]')];
  let selected = buttons[1], pixels;
  try { selected = buttons.find(button => button.dataset.stainName === localStorage.getItem('gcs-oak-stain')) || selected; } catch {}
  function draw(target, color) {
    const context = target.getContext('2d');
    const tinted = new ImageData(new Uint8ClampedArray(pixels.data), pixels.width, pixels.height);
    const rgb = color.match(/\w\w/g).map(value => parseInt(value, 16));
    for (let i = 0; i < tinted.data.length; i += 4) {
      if (!tinted.data[i + 3]) continue;
      const grain = (pixels.data[i] * .2126 + pixels.data[i + 1] * .7152 + pixels.data[i + 2] * .0722) / 198;
      for (let channel = 0; channel < 3; channel++) tinted.data[i + channel] = Math.min(255, rgb[channel] * Math.pow(grain, 1.2));
    }
    const board = document.createElement('canvas');
    board.width = pixels.width; board.height = pixels.height;
    board.getContext('2d').putImageData(tinted, 0, 0);
    context.clearRect(0, 0, target.width, target.height);
    context.drawImage(board, 0, 0, target.width, target.height);
  }
  function select(button) {
    selected = button;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    title.textContent = button.dataset.stainName;
    preview.setAttribute('aria-label', button.dataset.stainName + ' stain preview on oak');
    if (pixels) draw(preview, button.dataset.stainColor);
    try { localStorage.setItem('gcs-oak-stain', button.dataset.stainName); } catch {}
  }
  buttons.forEach(button => button.addEventListener('click', () => select(button)));
  function prepare() {
    if (pixels || !source.naturalWidth) return;
    const board = document.createElement('canvas');
    board.width = 700; board.height = Math.round(700 * source.naturalHeight / source.naturalWidth);
    board.getContext('2d').drawImage(source, 0, 0, board.width, board.height);
    try { pixels = board.getContext('2d').getImageData(0, 0, board.width, board.height); }
    catch { root.querySelector('[data-stain-error]').hidden = false; return; }
    preview.width = board.width; preview.height = board.height;
    buttons.forEach(button => { const thumb = button.querySelector('canvas'); thumb.style.backgroundColor = 'transparent'; draw(thumb, button.dataset.stainColor); });
    source.hidden = true; preview.hidden = false; select(selected);
  }
  source.addEventListener('load', prepare);
  source.addEventListener('error', () => { root.querySelector('[data-stain-error]').hidden = false; });
  if (source.complete) prepare();
})();
